import { render, staticRenderFns } from "./TicketTabDetail.vue?vue&type=template&id=39868d18&scoped=true&"
import script from "./TicketTabDetail.vue?vue&type=script&lang=js&"
export * from "./TicketTabDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39868d18",
  null
  
)

export default component.exports